<template>
    <li ref="itemRef" class="flex">
        <slot />
    </li>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import BreadcrumbSeparator from './breadcrumb-separator.vue'

const itemRef = useTemplateRef<HTMLElement>('itemRef')

defineExpose({
    itemRef,
})
</script>
